import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { SponsorCardModel } from '../../../../models/sponsor-card.model';
import { AlertService } from '../../../../services/alert.service';
import { SponsorCardService } from '../../../../services/sponsor-card.service';

type AssociationPartner = {
  abbreviation: string;
  name: string;
  logo: string;
  wideLogo?: boolean;
};

@Component({
  selector: 'app-cooperations',
  templateUrl: './cooperations.component.html',
  styleUrl: './cooperations.component.scss',
  standalone: false,
})
export class CooperationsComponent implements OnInit {
  public sponsorCards: SponsorCardModel[] = [];
  public loading = true;

  public readonly associationPartners: AssociationPartner[] = [
    {
      abbreviation: 'BED',
      name: 'Bundesverband für Ergotherapeut:innen in Deutschland e.V.',
      logo: 'assets/images/associations/bed.png',
      wideLogo: true,
    },
    {
      abbreviation: 'LOGO D',
      name: 'LOGO Deutschland Selbstständige in der Logopädie e.V.',
      logo: 'assets/images/associations/logo-d.png',
      wideLogo: true,
    },
    // {
    //   abbreviation: 'VDD',
    //   name: 'Verband der Diätassistenten Deutscher Bundesverband e.V.',
    //   logo: 'assets/images/associations/vdd.webp',
    // },
    {
      abbreviation: 'VDB',
      name: 'VDB-Physiotherapieverband e.V. Bundesverband',
      logo: 'assets/images/associations/vdb.png',
    },
  ];

  constructor(
    private sponsorCardService: SponsorCardService,
    private alertService: AlertService
  ) {}

  public ngOnInit(): void {
    this.sponsorCardService
      .getActiveSponsorCards()
      .pipe(take(1))
      .subscribe({
        next: sponsorCards => {
          this.sponsorCards = this.getOneCardPerPartner(sponsorCards);
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.alertService.showErrorAlert(
            'Die Kooperationspartner konnten nicht geladen werden.'
          );
        },
      });
  }

  public openLink(sponsorCard: SponsorCardModel): void {
    if (sponsorCard.link) {
      window.open(sponsorCard.link, '_blank');
    }
  }

  private getOneCardPerPartner(cards: SponsorCardModel[]): SponsorCardModel[] {
    const seenPartnerIds = new Set<number>();

    return cards.filter(card => {
      if (card.idUser == null) {
        return true;
      }
      if (seenPartnerIds.has(card.idUser)) {
        return false;
      }
      seenPartnerIds.add(card.idUser);
      return true;
    });
  }
}
